import React from "react";
import PropTypes from "prop-types";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
  Autocomplete,
  Box,
  CircularProgress,
} from "@mui/material";
import { useTranslation } from "react-i18next";

const AddSubDialog = ({
  open,
  onClose,
  jobs,
  filteredEmployees,
  selectedJobId,
  setSelectedJobId,
  selectedEmployees,
  setSelectedEmployees,
  handleSave,
  loading,
}) => {
  const { t } = useTranslation();
  return (
    <Dialog open={open} onClose={onClose} fullWidth maxWidth="sm">
      <DialogTitle>{t("admin.employees.AddSubordinates.DialogTitle")}</DialogTitle>
      <DialogContent>
        <Box mb={2}>
          <Autocomplete
            options={jobs}
            getOptionLabel={(option) => option.jobName}
            onChange={(e, value) => setSelectedJobId(value ? value.jobId : null)}
            renderInput={(params) => (
              <TextField {...params} label={t("admin.employees.AddSubordinates.FilterByJob")} />
            )}
          />
        </Box>
        <Autocomplete
          multiple
          options={
            selectedJobId
              ? filteredEmployees.filter((e) => e.jobId === selectedJobId)
              : filteredEmployees
          }
          getOptionLabel={(option) => option.name}
          value={selectedEmployees}
          onChange={(event, newValue) => setSelectedEmployees(newValue)}
          renderInput={(params) => (
            <TextField {...params} label={t("admin.employees.AddSubordinates.SelectEmployees")} />
          )}
        />
      </DialogContent>
      {loading ? (
        <Box display="flex" justifyContent="flex-end" p={1}>
          <CircularProgress size={20} sx={{ color: "black" }} />
        </Box>
      ) : (
        <DialogActions>
          <Button onClick={onClose} color="secondary">
            {t("admin.employees.AddSubordinates.Cancel")}
          </Button>
          <Button
            onClick={handleSave}
            color="primary"
            sx={{ "&:hover": { backgroundColor: "blue", color: "#fff" } }}
          >
            {t("admin.employees.AddSubordinates.Save")}
          </Button>
        </DialogActions>
      )}
    </Dialog>
  );
};

AddSubDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  jobs: PropTypes.array.isRequired,
  filteredEmployees: PropTypes.array.isRequired,
  selectedJobId: PropTypes.number,
  setSelectedJobId: PropTypes.func.isRequired,
  selectedEmployees: PropTypes.isRequired,
  setSelectedEmployees: PropTypes.func.isRequired,
  selectedManagerId: PropTypes.number.isRequired,
  allEmps: PropTypes.array.isRequired,
  setAllEmps: PropTypes.func.isRequired,
  setEmployees: PropTypes.func.isRequired,
  handleSave: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
};

export default AddSubDialog;
